import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/consent")({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect:
      typeof search.redirect === "string" && search.redirect.startsWith("/") && !search.redirect.startsWith("//")
        ? search.redirect
        : "/",
  }),
  staticData: { hideHeader: true },
  component: Outlet,
});
